'use es6';

import http from 'hub-http/clients/apiClient';
/**
 * PUT designmanager/v1/layouts/:id/buffer
 */

export function save(layoutId, layout) {
  return http.put(`designmanager/v1/layouts/${layoutId}/buffer/raw`, {
    data: layout,
    timeout: 30000,
    query: {
      designManagerUpdatedFrom: 'IDE'
    }
  });
}
/*
 * GET designmanager/v1/layouts/:id/buffer
 *
 * @param {(Number|String)} layoutId
 * @param {Object}          query - Optional query params.
 */

export function fetch(layoutId, query = {}) {
  return http.get(`designmanager/v1/layouts/${layoutId}/buffer`, {
    query
  });
}